import React, { useRef, useState } from "react";
import { AppointmentDashboardDTO, DocumentDashboardDTO, ReceiptDashboardDTO, ServiceDashboardDTO, ShoppingCartDashboardDTO } from "../../../../../api/DashboardWidgetDTO";
import { useMediaQuery, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Avatar, IconButton, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button, useTheme, Box, CircularProgress } from "@mui/material";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { REACT_APP_PORTAL_API_URL, REACT_APP_PUBLIC_API_URL } from "../../../../../KeyVariables";
import { handleDownload } from "./AnalyzisArchive";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DashboardWidgetsClient } from "../../../../../api/DashboardWidgetsClient";

export interface PaymentsArchiveProps {
  items: ShoppingCartDashboardDTO[];
}

export const ShoppingCartsArchive = ({ items }: PaymentsArchiveProps) => {
  const { t }: { t: any } = useTranslation('Portal');
  const iframeRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const mapStatusColor = (id) => {
    switch (id) {
      case "confirmed":
        return "rgba(255, 238, 0, 0.1)";
      case "paid":
        return "rgba(0, 255, 0, 0.1)";
      case "pending":
        return "rgba(0, 0, 0, 0.1)";
      case "returned":
      return "rgba(0, 0, 0, 0.1)";
      default:
        return "none";
    }
  }

  const mapStatusName = (id) => {
    switch (id) {
      case "confirmed":
        return t('Portal_PaymentIsOk');
      case "paid":
        return t('Portal_Paid');
      case "pending":
        return t('Portal_TransactionInProcess');
      case "returned":
      return t('Portal_Reimbursed');
      default:
        return "none";
    }
  }


  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('Portal_CommonDate')}</TableCell>
            <TableCell>{t('Portal_CommonStatus')}</TableCell>
            <TableCell>{t('Portal_Sum')}</TableCell>
            <TableCell>{t('Portal_PaymentType')}</TableCell>
            <TableCell>{t('Portal_Details')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.length > 0 ? (
            items.map((item, index) => (
              <TableRow key={index}>
                <TableCell>{item.date ? format(item.date, "dd.MM.yyyy") : "-"}</TableCell>
                <TableCell>
                  <Box sx={{ backgroundColor: mapStatusColor(item.status), p: 1, borderRadius: 1, textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {item.status ? mapStatusName(item.status) : "-"}
                  </Box>
                </TableCell>
                <TableCell>{item.price ? `${item.price.toFixed(2)} lei` :  "-"}</TableCell>
                <TableCell>
                  {item.paymentType || "-"}
                </TableCell>
                <TableCell>
                  <IconButton onClick={() => window.open('/shoppingcart/'+item.identity,'_self')}>
                    <VisibilityIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={5} align="center">
                <Typography>{t('Portal_NoCarts')}</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
